<fq-api-loader>
  @if (results$ | async; as asyncResult) {
    <div class="page--wrapper">
      <div class="page--main">
        <fq-header [headerType]="asyncResult.headerToGet"></fq-header>
        <router-outlet></router-outlet>
      </div>
      <div class="page--footer">
        <fq-footer [showInformationFooter]="asyncResult.showInformationFooter" [isBigInformationFooter]="asyncResult.isBigFooter"></fq-footer>
      </div>
    </div>
  }
</fq-api-loader>
